/**
 * WalkthroughCompleteModal — "You're all set" (Figma MVP-DESIGNES 9496:17932),
 * shown on the task page once the guided create-model walkthrough reached its
 * last step (after the training "processing" modal, if that one appeared).
 *
 * Same anatomy as the welcome modal, so it reuses `IllustratedCtaModal` with
 * its own artwork: the gradient header (Figma "Rectangle 1", 2× PNG export)
 * and the jack-in-the-box illustration (Figma "Group 30", one SVG) popping out
 * above the modal. Confetti bursts in from both side edges behind the dialog
 * (Spark `Confetti` in the portal's backdrop slot), ends on its own after 4 s,
 * and when the modal is closed earlier it fades out together with the backdrop
 * (0.2 s portal fade) and unmounts with it.
 */
import React from 'react';

import { Confetti } from '@spark';

import IllustratedCtaModal from '@/shared/components/IllustratedCtaModal';
import WalkthroughCompleteBox from '@/shared/assets/illustrations/walkthrough-complete-box.svg?react';
import walkthroughCompleteHeader from '@/shared/assets/illustrations/walkthrough-complete-header.png';

import './WalkthroughCompleteModal.css';

export const WALKTHROUGH_COMPLETE_TITLE = "You're all set 🎉";
export const WALKTHROUGH_COMPLETE_BODY =
    "You've successfully finished all steps of the guide. You're now ready to apply what you've learned and build your own custom models.";
export const WALKTHROUGH_COMPLETE_CTA = 'Get Started';

export default function WalkthroughCompleteModal({ open = false, onClose }) {
    return (
        <IllustratedCtaModal
            open={open}
            onClose={onClose}
            className="walkthrough-complete-modal"
            title={WALKTHROUGH_COMPLETE_TITLE}
            body={WALKTHROUGH_COMPLETE_BODY}
            ctaLabel={WALKTHROUGH_COMPLETE_CTA}
            backdrop={<Confetti />}
            artwork={
                <img
                    src={walkthroughCompleteHeader}
                    alt=""
                    aria-hidden="true"
                    className="illustrated-cta-modal__artwork walkthrough-complete-modal__artwork"
                    data-testid="walkthrough-complete-modal-artwork"
                />
            }
            overlay={
                <WalkthroughCompleteBox
                    className="illustrated-cta-modal__star walkthrough-complete-modal__illustration"
                    data-testid="walkthrough-complete-modal-illustration"
                    aria-hidden="true"
                    focusable="false"
                />
            }
        />
    );
}
